import React , {memo, useCallback, useEffect, useRef} from 'react';
import { StyleSheet, Modal, Pressable } from 'react-native';

import GlobalPressable from '../button/GlobalPressable';

import { COLORS } from '@bcm/constants';
import commonStyles from '../styles/common';

const BCMModal = ({
	modalVisible,
	setModalVisible,
	onCancel,
	children,
}) => {
	const isMounted = useRef(false);

	const onRequestClose = useCallback(() => {
		setModalVisible(!modalVisible);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalVisible]);

	useEffect(() => {
		isMounted.current = true;
		return () => isMounted.current = false;
	}, []);

	return (
		<Modal
			animationType='fade'
			transparent
			visible={modalVisible}
			onRequestClose={onRequestClose}
		>
			<GlobalPressable
				style={styles.container}
				onPress={onCancel}
			>
				<Pressable style={styles.content}>
					{children}
				</Pressable>
			</GlobalPressable>
		</Modal>
	);
};

const styles = StyleSheet.create({
	container: {
		...commonStyles.containers.center,
		marginTop: 0,
		backgroundColor: COLORS.modalBackground,
	},
	// Wrapper needed allow child content to set width flexibly
	content: {
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 10,
		overflow: 'hidden',
	}
});

export default memo(BCMModal);
